import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler
  } from 'chart.js';

  import { Bar } from 'react-chartjs-2';
  import { t } from '../../../content';
  import { useLocale } from '../../../locale';
  import { metricTitle } from '../localizeAnalytics';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Title,
    Tooltip,
    Legend
  );

  export function MotivationCharts ({ title, topMotivations, lowMotivations, isLegendVisible = false }) {
    useLocale();

    const options = {
      indexAxis: 'y',
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        }
      },
      scales: {
          x: {
          beginAtZero: true,
          min: 0,
          max: 9,
          ticks: {
            font: { size: 14 },
          },
        },
        y: {
          ticks: {
            font: { size: 14 },
            crossAlign: "far",
          },
        }
      }
    };

    const labels = [];
    let newData = [];
    topMotivations.length > 0 && topMotivations
      .sort((a, b) => b.average - a.average)
      .forEach((data) => {
        labels.push(metricTitle(data.column_id, data.column_name));
        newData.push(data.average);
      });
    lowMotivations.length > 0 && lowMotivations
    .forEach((data) => {
        labels.push(metricTitle(data.column_id, data.column_name));
        newData.push(data.average);
    })


    const data = {
      labels,
      datasets: [
        {
          categoryPercentage: 1.0,
          barPercentage: 1.0,
          barThickness: 18,
          data: newData,
          backgroundColor: [...topMotivations?.map(() => '#00B0A0'), ...lowMotivations?.map(() => '#59287A')],
        }
      ],
    };


    return (
      <div className="mar-25 bottom" style={{width: '100%'}}>
        <p className="l bold">{title || t('analytics.chartTitles.valuesMotivation')}</p>
        {isLegendVisible && (
          <div className='legends' style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
            <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span className='legend-color-box' style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#00B0A0',
                    display: 'inline-block'
                }}></span>
                <span className='legend-label'>{t('analytics.highestMetrics')}</span>
            </span>
            <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span className='legend-color-box' style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#59287A',
                    display: 'inline-block'
                }}></span>
                <span className='legend-label'>{t('analytics.lowestMetrics')}</span>
            </span>
        </div>
        )}
        <div className="wrapper" style={{minHeight: '300px'}}>
          <Bar data={data} options={options} />
        </div>
      </div>
    )
}
